angular.module('Itao.IndicatorMap').directive('indicatorSetSelectBox', function (mapConfig, communeConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'indicatorSetSelectBox.html',
    restrict: 'E',
    scope: {
      indicatorSets: '=',
      selectedIndicatorSet: '=',
      onIndicatorSetSelect: '&',
      deselectAllIndicators: "&"
    },
    link: function (scope) {
      scope.selectIndicatorSet = function (indicatorSet) {
        scope.deselectAllIndicators();
        scope.onIndicatorSetSelect({indicatorSet: indicatorSet});
      };
      scope.$watch('pattern', function (newValue) {
        if (newValue != undefined) {
          if (newValue.length > 0) {
            scope.$broadcast('angular-ui-tree:expand-all');
          } else {
            scope.$broadcast('angular-ui-tree:collapse-all');
          }
        }
      });
    }
  };
});
